import { render } from "./Consultants.vue?vue&type=template&id=96c6254c"
import script from "./Consultants.vue?vue&type=script&lang=js"
export * from "./Consultants.vue?vue&type=script&lang=js"

import "./Consultants.vue?vue&type=style&index=0&id=96c6254c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__